<template>
  <div class="page">
      <h2>Presentations</h2><br>
      <presentations-list 
        :presentationsList="presentationsList"
      />
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import PresentationsList from '../components/presentations/PresentationsList'

export default {
  name: 'Presentations',
  components: {
    PresentationsList
  },
  data() {
      return {
      }
  },
  computed: {
      ...mapGetters([
        'presentationsList',
      ]),
  },
  methods: {
  },
  created() {
  }
}
</script>

<style scoped>
</style>
